import React, { useState } from "react";
import api from "../../../../services/api";
import {
  FaUser,
  FaTruck,
  FaUsers,
  FaKey,
  FaCheckCircle,
  FaRoute,
  FaLockOpen,
  FaUserCircle,
} from "react-icons/fa";
import styles from "./RouteCard.module.css";

export default function RouteCard({
  route,
  allUsers,
  accessByRoute,
  handleStatusChange,
  openAccessModal,
  openRouteModal,
  personnelByRoute,
  setRoutes,
  setAccessByRoute,
  highlighted,
  openActivityModal,
}) {
  const [removingUserId, setRemovingUserId] = useState(null);

  const pers = personnelByRoute[route.id] || {
    driver: "",
    loader1: "",
    loader2: "",
  };

  const { delivered, inProgress, undelivered, totalOrders } = getProgress(route.receipts);
  const deliveredWidth = totalOrders > 0 ? (delivered / totalOrders) * 100 : 0;
  const inProgressWidth = totalOrders > 0 ? (inProgress / totalOrders) * 100 : 0;
  const undeliveredWidth = totalOrders > 0 ? (undelivered / totalOrders) * 100 : 0;

  // пользователи с доступом
  const accessList = (accessByRoute[route.id] || [])
    .map((uid) => allUsers.find((u) => u.id === uid))
    .filter(Boolean);

  const visibleUsers = accessList.slice(0, 10);
  const hiddenCount = accessList.length - visibleUsers.length;

  // === Отзыв доступа ===
  const handleRevoke = async (user) => {
    const ok = window.confirm(`Вы действительно хотите забрать доступ у ${user.username}?`);
    if (!ok) return;

    try {
      setRemovingUserId(user.id);
      await api.delete("/route-access/revoke", {
        data: { userId: user.id, routeListId: route.id },
      });

      setRoutes((prev) =>
        prev.map((r) =>
          r.id === route.id
            ? {
                ...r,
                permittedUsers: (r.permittedUsers || []).filter((u) => u.id !== user.id),
              }
            : r
        )
      );

      setAccessByRoute((prev) => {
        const copy = { ...prev };
        copy[route.id] = (copy[route.id] || []).filter((id) => id !== user.id);
        return copy;
      });

      setTimeout(() => setRemovingUserId(null), 400);
    } catch (e) {
      console.error("Ошибка при отзыве доступа:", e);
      alert("Не удалось отозвать доступ.");
      setRemovingUserId(null);
    }
  };

  return (
<div
  key={`${route.id}-${highlighted}`} // 👈 перерисовывает элемент при каждом изменении highlighted
  className={`${styles.card} ${highlighted ? styles.highlighted : ""}`}
>
      {/* ===== Верхняя часть ===== */}
      <div className={styles.topSection}>
      <div className={styles.header}>
        <h3>
          <FaRoute /> №{route.route_number} ({route.route_date})
        </h3>

        <button
          className={styles.activityBtn}
          onClick={() => openActivityModal(route)}
          title="Посмотреть активность маршрута"
        >
          🕒 Активность
        </button>
      </div>

        <div className={styles.info}>
          <p>
            <FaTruck /> <b>Машина:</b> <span>{route.car || "—"}</span>
          </p>
          <p>
            <FaUser /> <b>Водитель:</b> <span>{pers.driver || "—"}</span>
          </p>
          <p>
            <FaUsers /> <b>Грузчики:</b> <span>{pers.loader1 || "—"}, {pers.loader2 || "—"}</span>
          </p>
          <p>
            <FaKey /> <b>Статус:</b> <span>{route.route_status}</span>
          </p>
        </div>

        <div className={styles.progress}>
          <div className={styles.bar}>
            <div className={styles.delivered} style={{ width: `${deliveredWidth}%` }} />
            <div className={styles.inProgress} style={{ width: `${inProgressWidth}%` }} />
            <div className={styles.undelivered} style={{ width: `${undeliveredWidth}%` }} />
          </div>
          <p className={styles.progressText}>
            {delivered}/{totalOrders} доставлено
          </p>
        </div>
      </div>

      {/* ===== Список пользователей ===== */}
      <div className={styles.middleSection}>
        <p className={styles.accessTitle}>
          <FaKey /> Доступ имеют:
        </p>
        {visibleUsers.length === 0 ? (
          <p className={styles.noAccess}>— Нет пользователей с доступом</p>
        ) : (
          <div className={styles.userChips}>
            {visibleUsers.map((user) => (
              <div
                key={user.id}
                className={`${styles.userChip} ${
                  removingUserId === user.id ? styles.removing : ""
                }`}
                title={`Убрать доступ для ${user.username}?`}
                onClick={() => handleRevoke(user)}
              >
                <FaUserCircle className={styles.userIcon} />
                <span>{user.username}</span>
              </div>
            ))}
            {hiddenCount > 0 && (
              <div className={styles.moreChip}>+{hiddenCount} ещё</div>
            )}
          </div>
        )}
      </div>

      {/* ===== Нижняя часть ===== */}
      <div className={styles.bottomSection}>
        <button
          className={`${styles.openBtn} ${
            route.route_status === "Открыт" ? styles.disabledBtn : ""
          }`}
          disabled={route.route_status === "Открыт"}
          onClick={() => handleStatusChange(route.id)}
        >
          <FaCheckCircle />{" "}
          {route.route_status === "Открыт" ? "Маршрут открыт" : "Открыть маршрут"}
        </button>

        <button className={styles.accessBtn} onClick={() => openAccessModal(route)}>
          <FaLockOpen /> Настроить доступ
        </button>
      </div>
    </div>
  );
}

function getProgress(receipts) {
  if (!Array.isArray(receipts)) {
    return { delivered: 0, inProgress: 0, undelivered: 0, totalOrders: 0 };
  }
  const totalOrders = receipts.length;
  const delivered = receipts.filter((r) => r.status === "Закрыта").length;
  const inProgress = receipts.filter((r) => r.status === "Открыта").length;
  const undelivered = receipts.filter((r) => r.status === "Не доставлено").length;
  return { delivered, inProgress, undelivered, totalOrders };
}
